/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import moment from "moment";
import currency from "currency.js";
import { Align } from "../../../../components/shared/Table/style";
import {
  GetRfqs200ResponseBlocksInnerLegsInner,
  InstrumentTypeResponse,
  SideResponse,
} from "../../../../codegen-api";
import { COLORS } from "../../../../constants/design/colors";
import { AssetTag, Ratio } from "./style";
import { nanosToSeconds } from "../../../../utils/date";
import TickerLogo from "../../../../components/shared/TickerLogo";
import { TradeCol } from "../../../../components/TicketDetails/TradeOrderBook/style";

export function generateLegTag(
  leg: GetRfqs200ResponseBlocksInnerLegsInner
): Array<string | JSX.Element> {
  if (leg.instrument_type === InstrumentTypeResponse.Option) {
    return [
      <AssetTag key={leg.instrument_id}>
        <TickerLogo asset={leg.asset} size={24} />
        {leg.asset}
      </AssetTag>,
      <span
        key={leg.instrument_id}
        style={{
          color:
            leg.side === "buy" ? COLORS.up.one : COLORS.down.one,
        }}
      >
        {leg.side}
      </span>,
      leg.option_type as string,
      moment.unix(nanosToSeconds(Number(leg.expiry))).format("DD MMM YYYY"),
      currency(leg.strike as string, { precision: 0 }).format(),
      <Ratio key={leg.instrument_id}>x{leg.ratio}</Ratio>,
    ];
  }
  return [
    <AssetTag key={leg.instrument_id}>
      <TickerLogo asset={leg.asset} size={24} />
      {leg.asset}
    </AssetTag>,
    <span
      key={leg.instrument_id}
      style={{
        color:
          leg.side === "buy" ? COLORS.up.one : COLORS.down.one,
      }}
    >
      {leg.side}
    </span>,
    leg.instrument_type,
    <Ratio key={leg.instrument_id}>x{leg.ratio}</Ratio>,
  ];
}

interface IBestCellProps {
  value: any;
  row: any;
  quoteByBlock: (blockId: string, side: SideResponse) => any;
}

export function BestBidCell({ value, row, quoteByBlock }: IBestCellProps) {
  const quote = quoteByBlock(row.original.block_id, SideResponse.Buy);
  const isTaker = row.original.role === "taker";

  // If this is your own quote, show
  if (quote) {
    return (
      <Align align="right">
        <TradeCol>
          <span style={{ color: COLORS.up.one }}>
            {currency(quote.limit_price || 0).format()}
          </span>
          <span>{quote.amount}</span>
        </TradeCol>
      </Align>
    );
  }
  if (!isTaker) {
    return (
      <Align align="right">
        <TradeCol>
          <span style={{ color: COLORS.up.one }}>$•••</span>
        </TradeCol>
      </Align>
    );
  }
  return (
    <Align align="right">
      <TradeCol>
        <span style={{ color: COLORS.up.one }}>
          {(value?.bids || []).length > 0
            ? currency(value?.bids?.[0][0] || 0).format()
            : "-"}
        </span>
        <span>
          {(value?.bids || []).length > 0 ? value?.bids?.[0][1] : "-"}
        </span>
      </TradeCol>
    </Align>
  );
}

export function BestAskCell({ value, row, quoteByBlock }: IBestCellProps) {
  const quote = quoteByBlock(row.original.block_id, SideResponse.Sell);
  const isTaker = row.original.role === "taker";

  // If this is your own quote, show
  if (quote) {
    return (
      <Align align="right">
        <TradeCol>
          <span style={{ color: COLORS.down.one }}>
            {currency(quote.limit_price || 0).format()}
          </span>
          <span>{quote.amount}</span>
        </TradeCol>
      </Align>
    );
  }
  if (!isTaker) {
    return (
      <Align align="right">
        <TradeCol>
          <span style={{ color: COLORS.down.one }}>$•••</span>
        </TradeCol>
      </Align>
    );
  }
  return (
    <Align align="right">
      <TradeCol>
        <span style={{ color: COLORS.down.one }}>
          {(value?.asks || []).length > 0
            ? currency(value?.asks?.[0][0] || 0).format()
            : "-"}
        </span>
        <span>
          {(value?.asks || []).length > 0 ? value?.asks?.[0][1] : "-"}
        </span>
      </TradeCol>
    </Align>
  );
}
